import { render, staticRenderFns } from "./HumanDetail.vue?vue&type=template&id=3bba6b2e&scoped=true&"
import script from "./HumanDetail.vue?vue&type=script&lang=js&"
export * from "./HumanDetail.vue?vue&type=script&lang=js&"
import style0 from "./HumanDetail.vue?vue&type=style&index=0&id=3bba6b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bba6b2e",
  null
  
)

export default component.exports